<template>
  <div id="app" ref="app">
    <template v-if="util.isFacebookWebview() || util.isLineWebview()">
      <div style="height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <img style="height: 110px; margin: 65px auto 0px auto; width: 100%; object-fit: scale-down;" :src="util.getImagePath(`promptpai_logo_${$i18n.locale}@original.png`)">
        <DownloadApp/>
      </div>
    </template>
    <template v-else>
      <Navbar v-if="$route.name !== 'PlaceQr' && $route.name !== 'UserQr'" />
      <router-view class="app-router-view" v-if="isFinished" />
      <div class="fullscreen-image-container" v-if="fullscreenImageSrc !== ''">
        <div class="transforming" v-show="isTranforming">{{ $t('fullScreenImage.transformimg') }}</div>
        <img :src="fullscreenImageSrc">
        <button class="close-button" @click="closeImageFullscreen">
          <img :src="util.getImagePath('x_white@2x.png')" :srcset="util.getImageSet('x_white')">
        </button>
        <div class="tool-list">
          <button class="flip-button h" @click="hFlip(fullscreenImageIndex)">
            <img :src="util.getImagePath('flip-24px.svg')">
          </button>
          <button class="flip-button v" @click="vFlip(fullscreenImageIndex)">
            <img :src="util.getImagePath('flip-24px.svg')">
          </button>
          <button class="rotate-button" @click="rotate(fullscreenImageIndex)">
            <img :src="util.getImagePath('rotate_right-24px.svg')">
          </button>
        </div>
      </div>
      <div class="main modal" :class="{'active': isActiveModal}">
        <Login v-if="showModalName === 'Login'" :initUsername="initUsername" :isActivatedMode="isActivatedMode" :isTransfer="isTransfer" />
        <ForgotPassword v-if="showModalName === 'ForgotPassword'" />
        <EditProfile v-if="showModalName === 'EditProfile'" :isResetPassword="isResetPassword" :oneTimeToken="oneTimeToken" />
        <AskForTransfer v-if="showModalName === 'AskForTransfer'" />
        <SharePlaceWidget v-if="showModalName === 'SharePlaceWidget'" :placeDetail="placeDetail" />
        <PlaceQrCard v-if="showModalName === 'PlaceQrCard'" :placeDetail="placeDetail" />
        <MyQrCard v-if="showModalName === 'MyQrCard'" />
        <CreatePlaceForm v-if="showModalName === 'CreatePlaceForm'" :location="location" :mode="mode" :promptpaiDescription="promptpaiDescription" />
        <QrReader v-if="showModalName === 'QrReader'" :isReadUser="isReadUser" :isReadPlace="isReadPlace" :selectedPromptpaiId="selectedPromptpaiId" />
        <SendPlaceForm v-if="showModalName === 'SendPlaceForm'" :uid="uid" :selectedPromptpaiId="selectedPromptpaiId" />
        <ReceivedPlaceList v-if="showModalName === 'ReceivedPlaceList'" />
        <PlaceImageGallery v-if="showModalName === 'PlaceImageGallery'" :initialImageList="imageList" :index="index" />
        <SettingLanguage v-if="showModalName === 'SettingLanguage'" />
        <ConfirmDelete v-if="showModalName === 'ConfirmDelete'" :promptpaiDescription="promptpaiDescription" />
        <AddPlaceImageForm v-if="showModalName === 'AddPlaceImageForm'" :promptpaiDescription="promptpaiDescription" :initImageList="imageList" :immediately="immediately" />
        <SettingBaseMap v-if="showModalName === 'SettingBaseMap'" :map="map" />
        <!-- <PdpaManagement v-if="showModalName === 'PdpaManagement'" /> -->
      </div>
      <div class="alert-list">
        <transition-group name="alert">
          <div v-for="alert in alertList" :key="alert.key" class="alert" @click="clickAlert(alert)">
            <div class="icon">
              <img :src="alert.data.sender.profile_picture_fullpath">
            </div>
            <div class="detail">
              <div class="title">{{ $i18n.locale === 'en' && 'noti_title_en' in alert.data ? alert.data.noti_title_en : alert.data.noti_title_th }}</div>
              <div class="body" v-html="`${$i18n.locale === 'en' && 'noti_msg_en' in alert.data ? alert.data.noti_msg_en : alert.data.noti_msg_th}<br>${alert.data.promptpai_id}<br>${$i18n.locale === 'en' && 'promptpai_name_en' in alert.data ? alert.data.promptpai_name_en : alert.data.promptpai_name_th}`"></div>
              <div class="datetime">{{ alert.data.datetime }}</div>
            </div>
            <button class="close-button" @click.stop="closeAlert(alert.key)">
              <img :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
            </button>
          </div>
        </transition-group>
      </div>
    </template>
  </div>
</template>

<script>
import DownloadApp from '@/components/DownloadApp.vue'
import Navbar from '@/components/Navbar.vue'
import Login from '@/components/Login.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import EditProfile from '@/components/EditProfile.vue'
import AskForTransfer from '@/components/AskForTransfer.vue'
import SharePlaceWidget from '@/components/SharePlaceWidget.vue'
import PlaceQrCard from '@/components/PlaceQrCard.vue'
import MyQrCard from '@/components/MyQrCard.vue'
import CreatePlaceForm from '@/components/CreatePlaceForm.vue'
import QrReader from '@/components/QrReader.vue'
import SendPlaceForm from '@/components/SendPlaceForm.vue'
import ReceivedPlaceList from '@/components/ReceivedPlaceList.vue'
import PlaceImageGallery from '@/components/PlaceImageGallery.vue'
import SettingLanguage from '@/components/SettingLanguage.vue'
import ConfirmDelete from '@/components/ConfirmDelete.vue'
import AddPlaceImageForm from '@/components/AddPlaceImageForm.vue'
import SettingBaseMap from '@/components/SettingBaseMap.vue'
// import PdpaManagement from '@/components/PdpaManagement.vue'
import { setTimeout } from 'timers'

export default {
  name: 'App',
  components: {
    DownloadApp,
    Navbar,
    Login,
    ForgotPassword,
    EditProfile,
    AskForTransfer,
    SharePlaceWidget,
    PlaceQrCard,
    MyQrCard,
    CreatePlaceForm,
    QrReader,
    SendPlaceForm,
    ReceivedPlaceList,
    PlaceImageGallery,
    SettingLanguage,
    ConfirmDelete,
    AddPlaceImageForm,
    SettingBaseMap
    // PdpaManagement
  },
  data () {
    return {
      isActiveModal: false,
      showModalName: '',
      id: undefined,
      placeDetail: undefined,
      location: undefined,
      isFinished: false,
      isReadUser: undefined,
      isReadPlace: undefined,
      uid: undefined,
      selectedPromptpaiId: undefined,
      imageList: [],
      initUsername: '',
      isActivatedMode: false,
      isTransfer: false,
      isResetPassword: false,
      oneTimeToken: '',
      mode: undefined,
      promptpaiDescription: undefined,
      map: undefined,
      index: undefined,
      alertList: [],
      startClientX: 0,
      endClientX: 0,
      fullscreenImageSrc: '',
      fullscreenImageIndex: null,
      isTranforming: false,
      immediately: false
    }
  },
  mounted () {
    var self = this
    self.checkDeviceId()
    self.checkAuthentication()
    self.checkUid()
    self.$root.$on('alert', self.alert)
    self.$root.$on('openModal', self.openModal)
    self.$root.$on('closeModal', self.closeModal)
    self.$root.$on('askForTransfer', self.askForTransfer)
    self.$root.$on('openImageFullscreen', self.openImageFullscreen)
    self.$root.$on('closeImageFullscreen', self.closeImageFullscreen)
    window.onresize = () => {
      self.$root.$emit('windowResize')
    }
    // window.ontouchstart = (e) => {
    //   self.touchStart(e)
    // }
    // window.ontouchend = (e) => {
    //   self.touchEnd(e)
    // }
  },
  methods: {
    openImageFullscreen ({src, index}) {
      var self = this
      self.isTranforming = false
      self.fullscreenImageSrc = src
      self.fullscreenImageIndex = index
    },
    closeImageFullscreen () {
      var self = this
      self.isTranforming = false
      self.fullscreenImageSrc = ''
      self.fullscreenImageIndex = null
    },
    hFlip (index) {
      var self = this
      self.isTranforming = true
      setTimeout(() => {
        self.$root.$emit('hFlip', index)
      }, 150)
    },
    vFlip (index) {
      var self = this
      self.isTranforming = true
      setTimeout(() => {
        self.$root.$emit('vFlip', index)
      }, 150)
    },
    rotate (index) {
      var self = this
      self.isTranforming = true
      setTimeout(() => {
        self.$root.$emit('rotate', index)
      }, 150)
    },
    touchStart (e) {
      var self = this
      self.startClientX = e.changedTouches[0].clientX
    },
    touchEnd (e) {
      var self = this
      var width = self.$refs['app'].clientWidth
      self.endClientX = e.changedTouches[0].clientX
      if (self.startClientX >= 0 && width * 0.5 >= self.startClientX && self.endClientX >= width * 0.5 && width >= self.endClientX) {
        self.$root.$emit('showNavbar')
      } else if (self.endClientX >= 0 && width * 0.5 >= self.endClientX && self.startClientX >= width * 0.5 && width >= self.startClientX) {
        self.$root.$emit('hideNavbar')
      }
    },
    checkDeviceId () {
      var self = this
      if (!self.isKeyPromptPaiCookies('deviceId')) {
        var uniqueId = () => {
          var chr4 = () => {
            return Math.random().toString(16).slice(-4)
          }
          return `${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`
        }
        self.setPromptPaiCookies('deviceId', JSON.stringify(uniqueId()), Infinity, '/')
      }
    },
    checkAuthentication () {
      var self = this
      if (!self.isKeyPromptPaiCookies('isAuthenticated')) {
        self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
      }
    },
    checkUid () {
      var self = this
      if (!self.isKeyPromptPaiCookies('Uuid')) {
        self.pp.getUuid(undefined, (result) => {
          if (result.status.code === 200) {
            self.setPromptPaiCookies('Uuid', JSON.stringify(result.data), Infinity, '/')
            self.isFinished = true
          } else if (result.status.code === 403) {
          } else {
          }
        })
      } else {
        self.isFinished = true
      }
    },
    openModal (value) {
      var self = this
      self.id = undefined
      self.placeDetail = undefined
      self.isReadUser = undefined
      self.isReadPlace = undefined
      self.uid = undefined
      self.imageList = []
      self.initUsername = ''
      self.isActivatedMode = false
      self.isTransfer = false
      self.isResetPassword = false
      self.oneTimeToken = ''
      self.mode = undefined
      self.promptpaiDescription = undefined
      self.map = undefined
      self.immediately = false
      self.showModalName = value.name
      switch (self.showModalName) {
        case 'Login':
          self.initUsername = 'initUsername' in value ? value.initUsername : ''
          self.isActivatedMode = 'isActivatedMode' in value ? value.isActivatedMode : false
          self.isTransfer = 'isTransfer' in value ? value.isTransfer : false
          break
        case 'ForgotPassword':
          break
        case 'EditProfile':
          self.isResetPassword = 'isResetPassword' in value ? value.isResetPassword : false
          self.oneTimeToken = 'oneTimeToken' in value ? value.oneTimeToken : ''
          break
        case 'AskForTransfer':
          break
        case 'SharePlaceWidget':
          self.placeDetail = value.placeDetail
          break
        case 'PlaceQrCard':
          self.placeDetail = value.placeDetail
          break
        case 'MyQrCard':
          break
        case 'CreatePlaceForm':
          self.location = value.location
          self.promptpaiDescription = 'promptpaiDescription' in value ? value.promptpaiDescription : undefined
          self.mode = 'mode' in value ? value.mode : 'CREATE'
          break
        case 'QrReader':
          self.isReadUser = 'isReadUser' in value ? value.isReadUser : undefined
          self.isReadPlace = 'isReadPlace' in value ? value.isReadPlace : undefined
          self.selectedPromptpaiId = 'selectedPromptpaiId' in value ? value.selectedPromptpaiId : undefined
          break
        case 'SendPlaceForm':
          self.uid = value.uid
          self.selectedPromptpaiId = 'selectedPromptpaiId' in value ? value.selectedPromptpaiId : undefined
          break
        case 'PlaceImageGallery':
          self.imageList = 'imageList' in value ? value.imageList : []
          self.index = 'index' in value ? value.index : 0
          break
        case 'SettingLanguage':
          break
        case 'ConfirmDelete':
          self.promptpaiDescription = 'promptpaiDescription' in value ? value.promptpaiDescription : undefined
          break
        case 'AddPlaceImageForm':
          self.promptpaiDescription = 'promptpaiDescription' in value ? value.promptpaiDescription : undefined
          self.imageList = 'imageList' in value ? value.imageList : []
          self.immediately = value.immediately || false
          break
        case 'SettingBaseMap':
          self.map = 'map' in value ? value.map : undefined
          break
        // case 'PdpaManagement':
        //   break
      }
      self.$router.push(`${self.$route.path}#modal`)
      self.isActiveModal = true
    },
    closeModal () {
      var self = this
      self.showModalName = ''
      self.isActiveModal = false
    },
    alert (type, data) {
      var self = this
      var key = new Date().getTime() + data.noti_id
      self.alertList.unshift({
        key: key,
        data: data,
        type: type
      })
      setTimeout(() => {
        self.closeAlert(key)
      }, 30 * 1000)
    },
    closeAlert (key) {
      var self = this
      var index = self.alertList.map(a => a.key).indexOf(key)
      if (index !== -1) {
        self.alertList.splice(index, 1)
      }
    },
    clickAlert (alert) {
      var self = this
      self.closeAlert(alert.key)
      self.$router.push({
        path: `/p/${alert.data.promptpai_id}`,
        query: {
          notiid: alert.data.noti_id
        }
      })
    },
    askForTransfer () {
      var self = this
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (!isAuthenticated) {
        self.$root.$emit('openModal', {
          name: 'AskForTransfer'
        })
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      var self = this
      self.$nextTick(() => {
        self.setPromptPaiCookies('lang', JSON.stringify(self.$i18n.locale), Infinity, '/')
      })
    },
    $route (newRoute, oldRoute) {
      var self = this
      window.gtag('config', 'UA-143787399-1', {
        'page_path': newRoute.fullPath
      })
      self.$nextTick(() => {
        if (oldRoute.hash === '#modal' && (newRoute.hash === '' || newRoute.hash === '#max' || newRoute.hash === '#min')) {
          self.closeModal()
        }
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('alert')
    self.$root.$off('openModal')
    self.$root.$off('closeModal')
  }
}
</script>

<style>
  @font-face {
    font-family: Default-PromptPai;
    src: url(assets/font/Sarabun-Light.ttf);
  }

  @font-face {
    font-family: Default-PromptPai-Medium;
    src: url(assets/font/Sarabun-Regular.ttf);
  }

  @font-face {
    font-family: Prompt;
    src: url(assets/font/Prompt-Regular.ttf);
  }

  @font-face {
    font-family: Prompt-ExtraLight;
    src: url(assets/font/Prompt-ExtraLight.ttf);
  }

  * {
    font-family: Default-PromptPai;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    color: rgb(74, 74, 74);
    /* -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; */
    outline: none;
  }

  /* smartphones, touchscreens */
  @media (hover: none) and (pointer: coarse) {
    *::-webkit-scrollbar {
      display: none;
    }
  }
  /* stylus-based screens */
  @media (hover: none) and (pointer: fine) {
    *::-webkit-scrollbar {
      display: none;
    }
  }
  /* Nintendo Wii controller, Kinect */
  @media (hover: hover) and (pointer: coarse) {
    *::-webkit-scrollbar {
      display: none;
    }
  }

  ::-webkit-search-cancel-button{
    appearance: none;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    visibility: hidden;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    visibility: hidden;
  }
  *::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  *::-webkit-scrollbar-thumb {
    background: rgb(35, 87, 163);
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    border: none;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track:hover {
    background: transparent;
  }
  ::-webkit-scrollbar-track:active {
    background: transparent;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  html {
    min-width: 320px;
    min-height: 480px;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    /* background-image: url(/static/image_asset/background_2560.jpg);
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat; */
    position: relative;
    /* background-color: rgb(84, 129, 194); */
    overflow: hidden;
  }

  body {
    background-image: url(/static/image_asset/background_2560.jpg);
    background-color: rgb(34, 84, 156);
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
  }

  body,
  #app {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-y: auto;
  }

  * {
    appearance: none;
  }

  .modal {
    min-height: 480px;
    min-width: 320px;
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 900;
    top: 0px;
    display: none;
    box-sizing: border-box;
  }

  .modal.active {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-bottom-left-map-ui {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    bottom: 8px !important;
    left: 8px !important;
  }

  .custom-bottom-right-map-ui {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    bottom: 8px !important;
    right: 8px !important;
  }

  .ldmap_placeholder .ldmap_legend {
    position: absolute;
    right: 50px;
    bottom: 11px;
  }

  .ldmap_placeholder .ldmap_contextmenu .ldmap_contextmenu_icon {
    margin-top: 5px;
  }

  .ldmap_placeholder .ldmap_contextmenu .ldmap_contextmenu_poi {
    height: unset !important;
    line-height: 1.4;
  }

  .ldmap_placeholder .ldmap_toast {
    width: max-content !important;
    padding: 8px;
  }

  .ldmap_notice * {
    text-shadow: 
      -1px -1px 0 rgb(255, 255, 255),  
      1px -1px 0 rgb(255, 255, 255),
      -1px 1px 0 rgb(255, 255, 255),
      1px 1px 0 rgb(255, 255, 255);
  }

  .alert-required {
    background-color: rgb(252, 222, 242) !important;
  }

  /**
  * ----------------------------------------
  * promptpai noti/alert
  * ----------------------------------------
  */

  .alert-list {
    z-index: 999;
    position: fixed;
    top: 10px;
    right: 10px;
    display: flex;
    /* display: none; */
    flex-direction: column;
    align-items: flex-end;
  }

  .alert {
    z-index: inherit;
    /* color: rgb(255, 255, 255); */
    padding: 10px;
    width: fit-content;
    width: 300px;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
    -webkit-appearance: none;
    margin-bottom: 10px;
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: row;
    position: relative;
    cursor: pointer;
  }

  .alert > .icon {
    width: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .alert > .icon > img {
    width: 32px;
    height: 32px;
  }

  .alert > .detail {
    width: calc(100% - 32px);
    padding-left: 10px;
  }

  .alert > .detail > .title {
    font-weight: bold;
    font-size: 18px;
  }

  .alert > .detail > .body {
    font-size: 18px;
    color: rgb(120, 120, 120);
    line-height: 1;
  }

  .alert > .detail > .datetime {
    color: rgb(120, 120, 120);
  }

  .alert-enter-active,
  .alert-leave-active {
    transition: all 0.5s;
  }
  .alert-enter {
    opacity: 0;
    transform: translateY(-40px);
  }
  .alert-leave-to {
    opacity: 0;
    transform: translateX(300px);
  }

  .alert.info {
    background-color: rgb(74, 144, 226);
  }

  .alert > button.close-button {
    border: none;
    background-color: transparent;
    height: 18px;
    width: 18px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .alert > button.close-button > img {
    height: 18px;
    width: 18px;
  }

  /**
  * ----------------------------------------
  * dol layer
  * ----------------------------------------
  */

  img.ldmap_tile_canvas[src*="mode=dol"] {
    filter: grayscale(1);
  }

  .ldmap_tile > .ldmap_tile > :nth-child(1) + canvas.ldmap_tile_canvas.ldmap_maparea {
    filter: grayscale(1) !important;
    opacity: 0.145 !important;
  }

  /**
  * ----------------------------------------
  * animation loading
  * ----------------------------------------
  */

  .loading-animation {
    margin: auto;
    /* z-index: 1000; */
    background-image: url(/static/image_asset/loading_step_white.png);
    background-size: 80px;
    width: 80px;
    height: 80px;
    animation: loading-keyframes steps(23, end) 1s infinite;
    -webkit-animation: loading-keyframes steps(23, end) 1s infinite;
  }

  .loading-animation.primary {
    background-image: url(/static/image_asset/loading_step_blue.png);
  }

  @keyframes loading-keyframes {
    0% {background-position-y: calc(23 * 80px);}
    100% {background-position-y: 0px;}
  }

  @-webkit-keyframes loading-keyframes {
    0% {background-position-y: calc(23 * 80px);}
    100% {background-position-y: 0px;}
  }

  /**
  * ----------------------------------------
  * animation complete
  * ----------------------------------------
  */

  .complete-animation {
    margin: auto;
    /* z-index: 1000; */
    background-image: url(/static/image_asset/complete_step_white.png);
    background-size: 80px;
    width: 80px;
    height: 80px;
    animation: complete-keyframes steps(16, end) 1s;
    -webkit-animation: complete-keyframes steps(16, end) 1s;
  }

  @keyframes complete-keyframes {
    0% {background-position-y: calc(16 * 80px);}
    100% {background-position-y: 0px;}
  }

  @-webkit-keyframes complete-keyframes {
    0% {background-position-y: calc(16 * 80px);}
    100% {background-position-y: 0px;}
  }

  @keyframes arrow-up-to-down-keyframes {
    0% {-o-transition: rotate(0deg); -ms-transform: rotate(0deg); /* IE 9 */ -webkit-transform: rotate(0deg); /* Safari */ transform: rotate(0deg);}
    100% {-o-transition: rotate(180deg); -ms-transform: rotate(180deg); /* IE 9 */ -webkit-transform: rotate(180deg); /* Safari */ transform: rotate(180deg);}
  }

  @-webkit-keyframes arrow-up-to-down-keyframes {
    0% {-o-transition: rotate(0deg); -ms-transform: rotate(0deg); /* IE 9 */ -webkit-transform: rotate(0deg); /* Safari */ transform: rotate(0deg);}
    100% {-o-transition: rotate(180deg); -ms-transform: rotate(180deg); /* IE 9 */ -webkit-transform: rotate(180deg); /* Safari */ transform: rotate(180deg);}
  }

  @keyframes arrow-down-to-up-keyframes {
    0% {-o-transition: rotate(180deg); -ms-transform: rotate(180deg); /* IE 9 */ -webkit-transform: rotate(180deg); /* Safari */ transform: rotate(180deg);}
    100% {-o-transition: rotate(0deg); -ms-transform: rotate(0deg); /* IE 9 */ -webkit-transform: rotate(0deg); /* Safari */ transform: rotate(0deg);}
  }

  @-webkit-keyframes arrow-down-to-up-keyframes {
    0% {-o-transition: rotate(180deg); -ms-transform: rotate(180deg); /* IE 9 */ -webkit-transform: rotate(180deg); /* Safari */ transform: rotate(180deg);}
    100% {-o-transition: rotate(0deg); -ms-transform: rotate(0deg); /* IE 9 */ -webkit-transform: rotate(0deg); /* Safari */ transform: rotate(0deg);}
  }

  /**
  * ----------------------------------------
  * animation rotate-center
  * ----------------------------------------
  */

  @-webkit-keyframes rotate-center {
    0% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
    }
  }
  @keyframes rotate-center {
    0% {
      -webkit-transform: rotate(0);
              transform: rotate(0);
    }
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
    }
  }
  .rotate-center {
    -webkit-animation: rotate-center 2s linear infinite ;
            animation: rotate-center 2s linear infinite ;
  }

  .ldmap_navigation.ldmap_maparea {
    top: unset;
    left: unset;
    right: 58px;
    bottom: 151px;
  }

  .ldmap_navigation.ldmap_maparea .ldmap_alert {
    border: none;
    border-radius: 4px;
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
    padding: 4px 8px 2px 8px;
    color: rgb(255, 255, 255);
    font-size: 16px;
  }

  .ldmap_navigation.ldmap_maparea .ldmap_alert .ldmap_alert_error {
    color: rgb(255, 255, 255);
  }

  .fullscreen-image-container {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.98);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 950;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fullscreen-image-container > img {
    /* width: 100%; */
    max-width: 100%;
    /* height: 100%; */
    max-height: 100%;
    object-fit: contain;
  }

  .fullscreen-image-container > .close-button {
    border: none;
    background-color: transparent;
    height: 32px;
    width: 32px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    position: absolute;
    top: 9px;
    right: 9px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.9);
    border-radius: 25px;
  }

  .fullscreen-image-container > .close-button > img {
    width: 16px;
    height: 16px;
  }

  .fullscreen-image-container > .tool-list {
    position: absolute;
    bottom: 9px;
    right: 9px;
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 3px 12px;
    border-radius: 19px;
    box-sizing: border-box;
  }

  .fullscreen-image-container > .tool-list > button {
    border: none;
    background-color: transparent;
    height: 32px;
    width: 32px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin: 0px 6px;
  }

  .fullscreen-image-container > .tool-list > button > img {
    width: 24px;
    height: 24px;
    filter: invert(1);
  }

  .fullscreen-image-container > .tool-list > button.flip-button.v > img {
    transform: rotate(-90deg);
  }

  .transforming {
    position: absolute;
    bottom: 9px;
    left: 9px;
    padding: 3px 12px;
    filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.5));
    color: rgb(255, 255, 255);
    font-weight: bold;
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  @media only screen and (max-width: 1440px) {
    body {
      background-image: url(/static/image_asset/background_1440.jpg);
    }
  }

  @media only screen and (max-width: 1024px) {
    body {
      background-image: url(/static/image_asset/background_1024.jpg);
    }
  }

  @media only screen and (max-width: 768px) {
    body {
      background-image: url(/static/image_asset/background_768.jpg);
    }
  }

  .shake {
    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(calc(0% - 1px), 0, 0);
    }
    20%,
    80% {
      transform: translate3d(calc(0% + 2px), 0, 0);
    }
    30%,
    50%,
    70% {
      transform: translate3d(calc(0% - 4px), 0, 0);
    }
    40%,
    60% {
      transform: translate3d(calc(0% + 4px), 0, 0);
    }
  }

  .shake-center {
    animation: shake-center 0.82s cubic-bezier(.36, .07, .19, .97) both;
  }

  @keyframes shake-center {
    10%,
    90% {
      transform: translate3d(calc(-50% - 1px), 0, 0);
    }
    20%,
    80% {
      transform: translate3d(calc(-50% + 2px), 0, 0);
    }
    30%,
    50%,
    70% {
      transform: translate3d(calc(-50% - 4px), 0, 0);
    }
    40%,
    60% {
      transform: translate3d(calc(-50% + 4px), 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue